/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parental_Controls_Quick_Action_SublineInputs */

const de_parental_controls_quick_action_subline = /** @type {(inputs: Parental_Controls_Quick_Action_SublineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volljährigkeit bestätigen und PIN verwalten`)
};

/** @type {(inputs: Parental_Controls_Quick_Action_SublineInputs) => LocalizedString} */
const en_parental_controls_quick_action_subline = de_parental_controls_quick_action_subline;

/**

* @param {Parental_Controls_Quick_Action_SublineInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const parental_controls_quick_action_subline = /** @type {((inputs?: Parental_Controls_Quick_Action_SublineInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parental_Controls_Quick_Action_SublineInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_parental_controls_quick_action_subline(inputs)
	return en_parental_controls_quick_action_subline(inputs)
});